import React from "react";
import { Box } from "@chakra-ui/react";
import TraitsCanvas from "components/TraitsCanvas";
import useDressingRoom from "hooks/useDressingRoom";

const TraitsPreviewContainer = () => {
  const { originalTraits, currentTraits } = useDressingRoom();

  return (
    <Box w="full">
      {originalTraits && currentTraits && (
        <TraitsCanvas traits={currentTraits} withV2Badge imagesSize="full" />
      )}
    </Box>
  );
};

export default TraitsPreviewContainer;
